import { useEffect } from "react";
import { useWatch } from "react-hook-form";

const useDiscountCalculation = (control, setValue, discountId) => {
  const tare = useWatch({ control, name: "tare", defaultValue: 0 });
  const balance = useWatch({ control, name: "balance", defaultValue: 0 });
  const ardido = useWatch({ control, name: "ardido", defaultValue: 0 });
  const avariado = useWatch({ control, name: "avariado", defaultValue: 0 });
  const impureza = useWatch({ control, name: "impureza", defaultValue: 0 });
  const umidade = useWatch({ control, name: "umidade", defaultValue: 0 });
  const quebrado = useWatch({ control, name: "quebrado", defaultValue: 0 });
  const verde = useWatch({ control, name: "verde", defaultValue: 0 });
  const ratePerc = Number(useWatch({ control, name: "ratePerc", defaultValue: 0 }));
  const rateKg = Number(useWatch({ control, name: "rateKg", defaultValue: 0 }));

  const findDiscountValue = (discountList, value) => {
    const discount = discountList?.find((item) => item.value === parseFloat(value));
    return discount ? discount.discountValue : 0;
  };

  useEffect(() => {
    if (balance) {
      const ardidoDiscountValue = findDiscountValue(discountId?.discount?.ardido, ardido);
      const avariadoDiscountValue = findDiscountValue(discountId?.discount?.avariado, avariado);
      const impurezaDiscountValue = findDiscountValue(discountId?.discount?.impureza, impureza);
      const umidadeDiscountValue = findDiscountValue(discountId?.discount?.umidade, umidade);
      const quebradoDiscountValue = findDiscountValue(discountId?.discount?.quebrado, quebrado);
      const verdeDiscountValue = findDiscountValue(discountId?.discount?.verde, verde);

      const discArdido = formatWeight(calculateDiscount(ardidoDiscountValue, balance, tare));
      const discAvariado = formatWeight(calculateDiscount(avariadoDiscountValue, balance, tare));
      const discImpureza = formatWeight(calculateDiscount(impurezaDiscountValue, balance, tare));
      const discUmidade = formatWeight(calculateDiscount(umidadeDiscountValue, balance, tare));
      const discQuebrado = formatWeight(calculateDiscount(quebradoDiscountValue, balance, tare));
      const discVerde = formatWeight(calculateDiscount(verdeDiscountValue, balance, tare));

      const discounts =
        (parseFloat(discArdido) || 0) +
        (parseFloat(discAvariado) || 0) +
        (parseFloat(discImpureza) || 0) +
        (parseFloat(discUmidade) || 0) +
        (parseFloat(discQuebrado) || 0) +
        (parseFloat(discVerde) || 0);

      setValue("rateKg", formatWeight(((ratePerc || 0) / 100) * (balance - tare)));
      setValue("ardidoWeight", discArdido);
      setValue("avariadoWeight", discAvariado);
      setValue("impurezaWeight", discImpureza);
      setValue("umidadeWeight", discUmidade);
      setValue("quebradoWeight", discQuebrado);
      setValue("verdeWeight", discVerde);
      setValue("labelWeightNotDiscount", formatWeight(balance - tare));
      setValue("labelDiscount", formatWeight(discounts));
      setValue("labelWeightAndRate", formatWeight(balance - tare - discounts));
    }
  }, [
    tare,
    balance,
    ardido,
    avariado,
    impureza,
    umidade,
    quebrado,
    verde,
    ratePerc,
    discountId,
    setValue,
  ]);

  useEffect(() => {
    if (balance) {
      const ardidoDiscountValue = findDiscountValue(discountId?.discount?.ardido, ardido);
      const avariadoDiscountValue = findDiscountValue(discountId?.discount?.avariado, avariado);
      const impurezaDiscountValue = findDiscountValue(discountId?.discount?.impureza, impureza);
      const umidadeDiscountValue = findDiscountValue(discountId?.discount?.umidade, umidade);
      const quebradoDiscountValue = findDiscountValue(discountId?.discount?.quebrado, quebrado);
      const verdeDiscountValue = findDiscountValue(discountId?.discount?.verde, verde);

      const discArdido = formatWeight(calculateDiscount(ardidoDiscountValue, balance, tare));
      const discAvariado = formatWeight(calculateDiscount(avariadoDiscountValue, balance, tare));
      const discImpureza = formatWeight(calculateDiscount(impurezaDiscountValue, balance, tare));
      const discUmidade = formatWeight(calculateDiscount(umidadeDiscountValue, balance, tare));
      const discQuebrado = formatWeight(calculateDiscount(quebradoDiscountValue, balance, tare));
      const discVerde = formatWeight(calculateDiscount(verdeDiscountValue, balance, tare));

      const discounts =
        (parseFloat(discArdido) || 0) +
        (parseFloat(discAvariado) || 0) +
        (parseFloat(discImpureza) || 0) +
        (parseFloat(discUmidade) || 0) +
        (parseFloat(discQuebrado) || 0) +
        (parseFloat(discVerde) || 0) + 
        (rateKg);

      setValue("ardidoWeight", discArdido);
      setValue("avariadoWeight", discAvariado);
      setValue("impurezaWeight", discImpureza);
      setValue("umidadeWeight", discUmidade);
      setValue("quebradoWeight", discQuebrado);
      setValue("verdeWeight", discVerde);
      setValue("labelWeightNotDiscount", formatWeight(balance - tare));
      setValue("labelDiscount", formatWeight(discounts));
      setValue("labelWeightAndRate", formatWeight(balance - tare - discounts));
    }
  }, [
    rateKg,
    tare,
    balance,
    ardido,
    avariado,
    impureza,
    umidade,
    quebrado,
    verde,
    discountId,
    setValue,
  ]);
};

const calculateDiscount = (discountValue, balance, tare) => {
  return discountValue !== null ? ((discountValue || 0) / 100) * (balance - tare) : "";
};

const formatWeight = (value) => {
  if (value === "" || value === null || isNaN(value)) return "0.000";
  return parseFloat(value).toFixed(0);
};

export default useDiscountCalculation;